import { styled } from 'mz-ui-kit'

export const Container = styled('div', ({ $palette }) => ({
  display: 'flex',
  justifyContent: 'center',
  color: `${$palette('white')}`,
  background: `${$palette('green')}`
}));

export const Content = styled('div', {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  maxWidth: '920px',
  fontSize: '14px',
  lineHeight: '16px',
  padding: '10px 40px'
});

export const Icon = styled('div', {
  fontSize: '18px'
});

export const Message = styled('div', {
  marginLeft: '6px'
});

export const Dismiss = styled('div', ({ $palette }) => ({
  position: 'absolute',
  right: '15px',
  cursor: 'pointer',
  color: `${$palette('white').setAlpha(0.7)}`,
  ':hover': { color: `${$palette('white')}` }
}));
